import { ADMIN_NAME_LIST as menu } from "react-lib/apps/USER/CardSettingDivision";

export const ADMIN_MENU_GROUPS = [
  { id: "accounts-access", messageId: "ADMIN_GROUP_ACCOUNTS", shortMessageId: "ADMIN_GROUP_ACCOUNTS_SHORT", icon: "users", menuKeys: [
    menu["สร้าง Official Account"], menu["ตั้งค่า Official Account"],
    menu["สิทธิการเข้าถึง Official Account"], menu.จัดการสิทธิ์, menu.จัดการพนักงาน, menu.ข้อมูลบุคลากร,
  ] },
  { id: "schedule-appointments", messageId: "ADMIN_GROUP_SCHEDULE", shortMessageId: "ADMIN_GROUP_SCHEDULE_SHORT", icon: "calendar alternate outline", menuKeys: [
    menu.ตารางผู้ให้บริการ, menu.เวลาเปิดให้บริการ, menu.ตั้งค่าวันหยุด, menu.ตั้งค่าแจ้งเตือนนัดหมาย,
  ] },
  { id: "services-pricing", messageId: "ADMIN_GROUP_SERVICES", shortMessageId: "ADMIN_GROUP_SERVICES_SHORT", icon: "tags", menuKeys: [
    menu.รายการบริการ, menu["Setting Package Lab"],
  ] },
  { id: "customers-marketing", messageId: "ADMIN_GROUP_CUSTOMERS", shortMessageId: "ADMIN_GROUP_CUSTOMERS_SHORT", icon: "bullhorn", menuKeys: [
    menu.MeCRM, menu.MePOSCRM, menu.MeCast, menu.MeForm, menu.Affiliate, menu.GenQRcode, menu.MeWeb,
  ] },
  { id: "finance-inventory", messageId: "ADMIN_GROUP_FINANCE", shortMessageId: "ADMIN_GROUP_FINANCE_SHORT", icon: "money bill alternate outline", menuKeys: [
    menu.หลักฐานการชำระเงิน, menu.MeERP, menu["Stock Management"],
  ] },
] as const;
